export default {
  DELETE: {
    TITLETACHE: ' Supprimer tache',
    DESC_1TACHE: 'suppression tache ...',
    DESC_2TACHE: 'Êtes-vous sûr de supprimer définitivement cette tache?',
    BTN_DELETETACHE: 'Supprimer',
    BTN_CANCELTACHE: 'Annuler',
  },
}
